/** Represents an error when a argument is null or undefined. */
export class ArgumentNullError extends Error {

  /** Initializes an ArgumentNullError instance. */
  constructor(private _paramName: string) {
    super('The following arguments are either null or undefined: ' + _paramName);
  }
}
